// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-header{display:flex;flex-direction:column;gap:4px}`, "",{"version":3,"sources":["webpack://./src/EmploymentBillboard/App/components/InfoHeader/InfoHeader.scss"],"names":[],"mappings":"AAAA,aACI,YAAA,CACA,qBAAA,CACA,OAAA","sourcesContent":[".info-header {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 4px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
